<rl-form-table-row>
	<ng-template rlFormTableLabel>{{ isDedicatedPanel ? "Report" : "Report Element" }}</ng-template>
	<ng-template rlFormTableControl>
		<div class="d-flex justify-content-between align-items-center">
			@if (selected?.name) {
				<strong>
					{{selected.name}}
				</strong>
			} @else {
				<em>No Report selected</em>
			}
			<button class="btn btn-link btn-sm" [ngbPopover]="reportPopover" #p="ngbPopover" [autoClose]="'outside'"
				[popoverClass]="'w-500px mw-100'" placement="right auto">Select Report</button>
			<ng-template #reportPopover>
				<rl-select-sigma-object [selectableLevels]="selectableLevels" [actionLabel]="'Select'"
					[selectedObjects]="selectedObjects" (onObjectSelected)="objectSelected($event);p.close()">
				</rl-select-sigma-object>
			</ng-template>
		</div>
	</ng-template>
</rl-form-table-row>

<rl-form-table-row>
	<ng-template rlFormTableLabel>Title</ng-template>
	<ng-template rlFormTableControl>
		<rl-text-input class="mb-4" [(ngModel)]="title" (ngModelChange)="updateParams()" [dataLabel]="'TitleInput'">
		</rl-text-input>
	</ng-template>
</rl-form-table-row>

<rl-form-table-row>
	<ng-template rlFormTableLabel>Context Filter</ng-template>
	<ng-template rlFormTableControl>
		<div class="d-flex align-items-center">
			<rl-dropdown-single class="flex-fill" [(ngModel)]="selectedControl" (ngModelChange)="controlChanged()"
				[options]="controlOptions" [showEmptyOption]="true" [placeholder]="'Not set'"
				[disabled]="isControlSelectDisabled" [ariaLabel]="'Context filter to auto populate'"
				[dataLabel]="'ControlSelect'" [attr.aria-busy]="isLoadingControls">
			</rl-dropdown-single>
			<span class="btn-icon btn-info btn-sm ms-1 cursor-pointer" role="button" aria-label="Help"
				ngbTooltip="Choose the filter that will be set when the Report opens.">
				<i class="fal fa-circle-question" aria-hidden="true"></i>
			</span>
		</div>
	</ng-template>
</rl-form-table-row>

<rl-form-table-row>
	<ng-template rlFormTableLabel>Filter Value</ng-template>
	<ng-template rlFormTableControl>
		<div class="d-flex align-items-center">
			<rl-dropdown-single class="flex-fill" [(ngModel)]="selectedSource" (ngModelChange)="updateParams()"
				[options]="sourceOptions" [showEmptyOption]="true" [placeholder]="'Not set'"
				[disabled]="!selectedControl" [ariaLabel]="'Value the context filter is set to'"
				[dataLabel]="'ControlSourceSelect'">
			</rl-dropdown-single>
			<span class="btn-icon btn-info btn-sm ms-1 cursor-pointer" role="button" aria-label="Help"
				ngbTooltip="Choose an ID field for your filter value. Context filters require a unique ID to correctly match and load the Record's data in the Report.">
				<i class="fal fa-circle-question" aria-hidden="true"></i>
			</span>
		</div>
	</ng-template>
</rl-form-table-row>

<rl-form-table-row>
	<ng-template rlFormTableLabel>Interactive Features</ng-template>
	<ng-template rlFormTableControl>
		<div class="d-flex align-items-center">
			<label class="form-check mb-0">
				<input type="checkbox" class="form-check-input" [(ngModel)]="isInteractive"
					(ngModelChange)="updateParams()" data-cy="enableInteractiveFeaturesCheckbox" />
				<span class="form-check-label">Enable interactive features</span>
			</label>
			<span class="btn-icon btn-info btn-sm ms-1 cursor-pointer" role="button" aria-label="Help"
				ngbTooltip="When enabled, users viewing the report on a record will see the element toolbar option, which provides export options, filtering, sorting, drill-down, and other interactive options. When disabled, the report is view-only.">
				<i class="fal fa-circle-question" aria-hidden="true"></i>
			</span>
		</div>
	</ng-template>
</rl-form-table-row>